import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import accounting from 'accounting';

import ConfirmationCard from '../../components/Shared/ConfirmationCardMultiActionsCard';
import TitleComponent from '../../components/Shared/TitleMultiActionsCard';
import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import { formatThousands } from '../../utils/fillDynamicText';
import { copyFor } from '../../copy/copy';

const DonationSuccess = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            peopleCount={props.peopleCount}
            thankYouText={props.thankYouText}
            titleComponent={
                <TitleComponent
                    titleNoRep={copyFor('feedback', 'donated', 'donation', undefined, {
                        amountFormated: props.amountFormated,
                        partnerName: props.partnerName
                    })}
                />
            }
            {...props}
        />
    </TransitionContainerNoExit>
);

DonationSuccess.propTypes = {
    peopleCount: PropTypes.string.isRequired,
    thankYouText: PropTypes.string.isRequired,
    amountFormated: PropTypes.string.isRequired,
    partnerName: PropTypes.string.isRequired
};

export default connect(
    state => ({
        peopleCount:
            state.donation.completeDonation !== undefined
                ? formatThousands(state.donation.completeDonation.endUsersCount)
                : '',
        amountFormated: accounting.formatMoney(state.donation.selectedAmount, '$', 0)
    }),
    {}
)(DonationSuccess);
